import React from 'react';
import { Link } from 'react-router-dom';
import { money, fmtTime } from '../../utils/helpers';
import { isPerUnit } from '../services/useServices';
import ServiceForm from '../services/ServiceForm';
import { useFunctionServices } from './useFunctionServices';

const statusChip = (s) => (s === 'Done' ? 'chip ok' : s === 'Confirmed' ? 'chip male' : s === 'Cancelled' ? 'chip danger' : 'chip pend');

// Phone version of the catering / services panel inside the function form:
// one card per service instead of a table.
export default function FunctionServicesMobile({ event, fn }) {
  const { svc, rows, totals, addFor, hasType } = useFunctionServices(event, fn?.FunctionId);
  if (!svc.canView) return null;

  return (
    <div className="fn-services">
      <div className="fn-services-head">
        <strong>Catering &amp; services</strong>
        <div className="spacer" />
        {svc.canAdd && <button type="button" className="btn primary sm" onClick={() => addFor('', fn)}>+ Service</button>}
      </div>

      {svc.canAdd && (
        <div className="ev-svc-add">
          {!hasType('Catering') && <button type="button" className="btn light sm" onClick={() => addFor('Catering', fn)}>+ Catering</button>}
          {!hasType('Event Management') && <button type="button" className="btn light sm" onClick={() => addFor('Event Management', fn)}>+ Event Mgmt</button>}
        </div>
      )}

      {rows.length === 0 ? (
        <div className="muted" style={{ fontSize: 12.5 }}>
          Add the caterer (plates, rate, advance) and the event manager. Menu and jobs live inside each service.
        </div>
      ) : (
        <>
          <div className="muted" style={{ fontSize: 12, marginBottom: 6 }}>
            {money(totals.total)} agreed · {money(totals.advance)} paid · <strong>{money(totals.balance)}</strong> balance{totals.units ? ` · ${totals.units} plates` : ''}
          </div>
          {rows.map(row => (
            <div key={row.ServiceId} className="card card-pad ev-svc-card">
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <strong>{row.ServiceType}</strong>
                <span className={statusChip(row.Status)}>{row.Status}</span>
                <div className="spacer" />
                {svc.canEdit && <button type="button" className="btn light sm" title="Edit" onClick={() => svc.openEdit(row)}>✎ Edit</button>}
              </div>
              <div className="muted" style={{ fontSize: 12.5 }}>
                {row.CompanyName || row.ContactName || row.VendorName || '—'}
                {row.ContactMobile ? ` · ${row.ContactMobile}` : ''}
              </div>
              <div style={{ fontSize: 12.5, marginTop: 4 }}>
                {fmtTime(row.StartTime) || '—'}{row.EndTime ? ` – ${fmtTime(row.EndTime)}` : ''}
                {' · '}{money(row.Rate)}{isPerUnit(row.RateType) ? ` × ${row.ConfirmedCount || 0}` : ''}
                {' = '}<strong>{money(row.TotalAmount)}</strong>
              </div>
              <div style={{ fontSize: 12.5 }}>Paid {money(row.AdvancePaid)} · Balance <strong>{money(row.BalanceAmount)}</strong></div>
              <Link className="btn light sm" style={{ marginTop: 6, display: 'inline-block' }} to={`/app/services/${row.ServiceId}`}>Menu / jobs</Link>
            </div>
          ))}
        </>
      )}

      {svc.open && <ServiceForm vm={svc} />}
    </div>
  );
}
